import AjaxUtility from "../../../../../ig_template/Resources/Public/Src/Js/Utility/AjaxUtility";
import {LineController, LineElement, PointElement, CategoryScale, LinearScale, Chart} from "chart.js";

$(document).ready(function () {
	// small plugin
	const container = $('.tx-ig-magicline-occupancy'),
		location = parseInt(container.data('location'));

	if(container.length > 0) {
		AjaxUtility.request(4952, {action: 'utilization', location: location}, {
			4952: 'tx_igmagiclineoccupancy_occupancy'
		})
			.done(response => {
				$('.tx-ig-magicline-occupancy').html(response);

				const $equalizerRow = $('.tx-ig-magicline-occupancy').closest('.row[data-equalizer]');

				if ($equalizerRow.length) {
					new Foundation.Equalizer($equalizerRow).applyHeight();
				}
			});
	}

	// large trends plugin
	const ctx = document.getElementById('occupancy-chart');

	if (ctx && trendData) {
		const data = trendData;
		const currentDate = new Date();
		//const dayData = data[currentDate.getDay()];
		const dayData = data[7];

		new Chart(ctx, {
			type: 'line',
			data: {
				labels: dayData.labels,
				datasets: [{
					data: dayData.dataPoints,
					fill: false,
					borderColor: 'rgb(75, 192, 192)',
					tension: 0.5
				}]
			},
			options: {
				plugins: {
					legend: {
						display: false
					}
				}
			}
		})
	}
});
